export type RedirectReason =
  | 'event-not-found'
  | 'slug-renamed'
  | 'locale-missing'
  | 'legacy-url'
  | 'unknown'

export const REDIRECT_LOG_REASON_KEY = 'redirectLogReason'

export const setRedirectLogReason = (reason: RedirectReason): void => {
  if (import.meta.client) {
    return
  }

  try {
    const event = useRequestEvent()
    if (event) {
      event.context[REDIRECT_LOG_REASON_KEY] = reason
    }
  } catch {
    // useRequestEvent is unavailable outside an active request
  }
}
